export const iconFontAwesomeUsersPeopleHotTubPerson = (
	<i className="fa-solid fa-hot-tub-person"></i>
);
